import { styled } from 'styled-components';
import { IGlobaVariables } from '../../../components/Layout/styles';

import { IBreadcrumbs1_1, defaultParams } from './params';

import getBackgroundImageStyles from '../../../utils/getBackgroundImageStyles';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: IBreadcrumbs1_1;
}>`
  margin-bottom: 40px;

  .breadcrumbs {
    min-height: ${({ $config: styles }) => styles.height};
    background: ${({ $config: styles }) => getBackgroundImageStyles(styles.backgroundImage)};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;

    &::before {
      content: '';
      display: ${({ $config: styles }) => (styles.group_blenda.boolean_showBlenda === 'true' ? 'block' : 'none')};
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background: ${({ $config: styles }) => styles.group_blenda.backgroundColor};
    }

    &-container {
      z-index: 2;
    }

    &-items {
      display: flex;
      align-items: center;
      height: 100%;
      gap: 7px;
      border-bottom: ${({ $config: styles }) => styles.borderBottom};
      white-space: nowrap;
      overflow-wrap: break-word;
      overflow: hidden;
      overflow-x: scroll;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }
    }

    &-item {
      color: ${({ $config: styles }) => styles.group_item.color};
      font-family: ${({ $config: styles }) => styles.group_item.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_item.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_item.fontSize};
      font-style: ${({ $config: styles }) => styles.group_item.fontStyle};
      line-height: ${({ $config: styles }) => styles.group_item.lineHeight};
      text-decoration: ${({ $config: styles }) => styles.group_item.textDecoration};
      transition: color 0.2s ease-in-out;

      &:hover {
        color: ${({ $config: styles }) => styles.group_item.hover_color};
        text-decoration: ${({ $config: styles }) => styles.group_item.hover_textDecoration};
      }

      svg {
        height: ${({ $config: styles }) => styles.group_svg.height};
        color: ${({ $config: styles }) => styles.group_svg.color};
      }

      &.last {
        pointer-events: none;
        color: ${({ $config: styles }) => styles.group_item.group_disabled.color};
      }
    }
  }
`;

export default Styles;
